import { render, staticRenderFns } from "./onDrawerBeforeClose-editor.vue?vue&type=template&id=41850d46&scoped=true&"
import script from "./onDrawerBeforeClose-editor.vue?vue&type=script&lang=js&"
export * from "./onDrawerBeforeClose-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41850d46",
  null
  
)

export default component.exports